import React, { useState } from 'react';
import '../styles/SmallCompCard.css';
import { CustomSwiper, Button, Badge, Distance, CompCardMap } from './';
import { colour, formatterLong, numberFormatter } from '../styles/GlobalStyles';
import { formatDaysOnMarket, getFlipDetails, getPriceField, getStatusDotColour, propertyStatusBG, propertyStatusText, propertyTypeFormatAbbreviated } from '../functions';
import { CloseCircle, Image } from '../assets/icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { Calendar03Icon } from '@hugeicons/core-free-icons';

function SmallCompCard(props) {
    const property = props.property;
    const closeCompCard = props.closeCompCard;
    const selected = props.selected;
    const addSelectedComp = props.addSelectedComp;
    const overlay = props.overlay;
    const showScrollableImages = props.showScrollableImages;
    const openDetailedView = props.openDetailedView;
    const expanded = props.expanded;
    const flipDetails = getFlipDetails(property);
    const flipStatus = flipDetails.flipStatus;
    const flipBGColour = flipDetails.flipBGColour;
    const flipDescription = flipDetails.flipDescription;
    const flipDotcolour = flipDetails.flipDotcolour;
    const propertyType = property.propertyAttributes.propertyType;
    const slideshow = props.slideshow;
    const subjectPropertyObject = props.subjectPropertyObject;
    const isLoaded = props.isLoaded;
    const bestComp = props.bestComp;
    const soldLabel = property.listingDetails.listingStatus === "for_sale" ? "Listed" : "Sold";
    const soldText = property.listingDetails.listingStatus === "for_sale" ? formatDaysOnMarket(property.listingDetails.saleListingDate) : formatDaysOnMarket(property.listingDetails.soldListingDate);
    const price = getPriceField(property) === null ? "Price unavailable" : formatterLong.format(getPriceField(property)).replace(".00", "");
    const [distanceHoverTimeout, setDistanceHoverTimeout] = useState(null);
    const [showMap, setShowMap] = useState(false);

    const turnOnMap = () => {
        setShowMap(true);
    };

    const turnOffMap = () => {
        setShowMap(false);
        setDistanceHoverTimeout(null);
    };

    return (
        <div 
            className="small-comp-card-outer-container bg-colour-white cursor-pointer relative-container"
        >
            {
                property.compDetails.distanceMiles !== null &&
                <Distance
                    value={`${property.compDetails.distanceMiles.toFixed(2)}mi`}
                    distanceHover={() => turnOnMap()}
                    showMap={showMap}
                    hoverTimeout={distanceHoverTimeout}
                    setHoverTimeout={setDistanceHoverTimeout}
                    darkMode={false}
                />
            }
            <div 
                className="small-comp-card-images-container relative-container"
                onMouseLeave={() => turnOffMap()}
            >
                {
                    showMap === true ?
                    <CompCardMap
                        isMapLoaded={isLoaded}
                        comp={property}
                        subjectProperty={subjectPropertyObject}
                        isMapActive={true}
                        bestComp={bestComp}
                    />
                    :
                    property.listingDetails.mlsPhotoUrls === null || property.listingDetails.mlsPhotoUrls.length === 0 ?
                    <div 
                        className="small-comp-card-no-image-container"
                    >
                        <Image
                            className="small-comp-card-no-image-element"
                            fill={colour.gray05}
                        />
                        <span className="label-regular colour-secondary block-text text-align-center">
                            No image
                        </span>
                    </div>
                    :
                    <CustomSwiper
                        images={property.listingDetails.mlsPhotoUrls}
                        imageLimit={100}
                        title=""
                        arrowClicked={null}
                        imageClick={() => expanded === false ? null : showScrollableImages(property)}
                    />
                }
                {
                    overlay === false && slideshow === false &&
                    <CloseCircle
                        className="small-comp-card-close-icon cursor-pointer"
                        clickFunc={() => closeCompCard()}
                        fill={colour.gray07}
                    />
                }
                {
                    slideshow === false && addSelectedComp !== null &&
                    <Button
                        buttonType={selected === false ? "primary-button" : "light-button"}
                        size="medium"
                        text={selected === false ? "Keep" : "Remove"}
                        cta={() => addSelectedComp(property)}
                        disabled={false}
                        leftIcon={null}
                        leftIconClass=""
                        rightIcon={null}
                        rightIconClass=""
                        alt=""
                        standardIcon={false}
                        badge={false}
                        badgeVal={null}
                        badgeBG={null}
                        buttonRef={null}
                        spinner={false}
                    />
                }
            </div>
            <div 
                className="small-comp-card-body-container"
                onClick={() => expanded === false ? null : openDetailedView === null ? null : openDetailedView(property)}
            >
                <div className="small-comp-card-body-row">
                    <span className="heading-small-bold colour-primary">
                        {price}
                    </span>
                    <div className="small-comp-card-body-right-container">
                        <Badge
                            bgColour={propertyStatusBG(property, false)}
                            text={propertyStatusText(property)}
                            statusDot={true}
                            statusDotColour={getStatusDotColour(property)}
                            textClass="body-semibold colour-primary"
                            icon={null}
                            tooltip={false}
                            tooltipBody={null}
                            tooltipPosition={null}
                            iconLeft={false}
                        />
                        <div className="small-comp-card-flip-badge-container relative-container">
                            {
                                property.compDetails.arv === true &&
                                <Badge
                                    bgColour={flipBGColour}
                                    text={flipStatus}
                                    statusDot={true}
                                    statusDotColour={flipDotcolour}
                                    textClass="body-semibold colour-primary"
                                    icon={null}
                                    tooltip={true}
                                    tooltipBody={flipDescription}
                                    tooltipPosition={"left"}
                                    iconLeft={false}
                                />
                            }
                        </div>
                    </div>
                </div>
                <div className="small-comp-card-details-container">
                    <span className="body-regular colour-secondary">
                        {property.propertyAttributes.bedrooms} bd
                    </span>
                    <span className="body-regular colour-secondary">
                        |
                    </span>
                    <span className="body-regular colour-secondary">
                        {property.propertyAttributes.bathrooms} ba
                    </span>
                    <span className="body-regular colour-secondary">
                        |
                    </span>
                    <span className="body-regular colour-secondary">
                        {numberFormatter.format(property.propertyAttributes.livingSquareFootage)} sqft
                    </span>
                    <span className="body-regular colour-secondary">
                        |
                    </span>
                    <span className="body-regular colour-secondary">
                        {propertyTypeFormatAbbreviated(propertyType)}
                    </span>
                </div>
                <span className="body-regular colour-tertiary">
                    {property.addressDetails.streetAddress}, {property.addressDetails.city}
                </span>
                <div className="small-comp-card-date-container">
                    <HugeiconsIcon icon={Calendar03Icon} color={colour.gray04} className="" size={16} />
                    <span className="body-regular colour-primary">
                        {soldLabel}
                        <span className="body-semibold colour-primary">
                            {" "}{soldText}
                        </span>
                    </span>
                </div>
            </div>
        </div>
    )
};

export default React.memo(SmallCompCard);